import updateSize from './updateSize';
import updateSlides from './updateSlides';
import updateAutoHeight from './updateAutoHeight';
import updateSlidesOffset from './updateSlidesOffset';
import updateSlidesProgress from './updateSlidesProgress';
import updateProgress from './updateProgress';
import updateSlidesClasses from './updateSlidesClasses';
import updateActiveIndex from './updateActiveIndex';
import updateClickedSlide from './updateClickedSlide';
export default {
  updateSize: updateSize,
  updateSlides: updateSlides,
  updateAutoHeight: updateAutoHeight,
  updateSlidesOffset: updateSlidesOffset,
  updateSlidesProgress: updateSlidesProgress,
  updateProgress: updateProgress,
  updateSlidesClasses: updateSlidesClasses,
  updateActiveIndex: updateActiveIndex,
  updateClickedSlide: updateClickedSlide
};


//////////////////
// WEBPACK FOOTER
// ./~/swiper/esm/components/core/update/index.js
// module id = 755
// module chunks = 169